module.exports = __webpack_public_path__ + "pcclient/img/record_no_image.9d0ea08a.png";